<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="centering">
        <v-row class="mx-12" justify="center">

          <!-- LEFT WING -->

          <v-col cols="7" align="center" class="left-wing hidden-md-and-down">
            <v-row justify="center">
              <h1 class="text text-uppercase display-2 font-weight-bold">
                Bienvenue sur
              </h1>
              <v-img
                class="my-5"
                src="/static/images/logo-spideup-white.png"
                width="300"
              ></v-img>
              <h1 class="text pt-5">
                Bienvenue sur la plateforme SpideUp, votre solution de mesure
                et de création de trafic dans votre point de vente
              </h1>
              <h1 class="text pt-5">
                Le meilleur de l'intéraction mobile pour votre clilentèle !
              </h1>
              <v-row class="footer">
                <v-img
                  contain
                  src="/static/images/logo-spideup-white.png"
                  width="100"
                ></v-img
                ><v-img class="white--text pl-2 pb-1">© 2023</v-img>
              </v-row>
            </v-row>
          </v-col>

          <!-- RIGHT WING -->

          <v-col cols="5" class="right-wing">
            <v-row class="text weight-bold size-xlarge pb-6">
              <strong>Réinitialisation du mot de passe</strong>
            </v-row>

            <v-row class="d-flex flex-column">
              <LoginInput
                class="login pt-0 pl-0"
                v-model="password"
                type="password"
                placeholder="Entrez votre nouveau mot de passe"
                @on-enter=""
              />
              <LoginInput
                class="login pt-0 pl-0"
                v-model="password_confirm"
                type="password"
                placeholder="Confirmez votre nouveau mot de passe"
                @on-enter=""
              />

              <v-col>
                <v-row class="pwd-indicator-title py-4">
                  Votre mot de passe doit contenir :
                </v-row>
                <v-row class="mt-0">
                   <v-col class="pwd-indicator-title" :class="has_minimum_lenth ? 'has_required' : ''" cols="12">
                    <v-icon v-show="has_minimum_lenth"  class="check-icon" small>check_circle_outline</v-icon><v-icon v-show="!has_minimum_lenth" class="wrong-icon" small>highlight_off</v-icon>
                    Entre 8 et 16 caractéres au minimum
                   </v-col>
                </v-row>
                <v-row class="mt-0">
                   <v-col class="pwd-indicator-title" :class="has_number ? 'has_required' : ''" cols="12">
                    <v-icon v-show="has_number" class="check-icon" small>check_circle_outline</v-icon><v-icon v-show="!has_number" class="wrong-icon" small>highlight_off</v-icon>
                    &nbsp;Au moins un chiffre
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                 <v-col class="pwd-indicator-title" :class="has_lowercase ? 'has_required' : ''" cols="12">
                    <v-icon v-show="has_lowercase" class="check-icon" small>check_circle_outline</v-icon><v-icon v-show="!has_lowercase" class="wrong-icon" small>highlight_off</v-icon>
                    &nbsp;Au moins une minuscule
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col class="pwd-indicator-title" :class="has_uppercase ? 'has_required' : ''" cols="12">
                    <v-icon v-show="has_uppercase" class="check-icon" small>check_circle_outline</v-icon><v-icon v-show="!has_uppercase" class="wrong-icon" small>highlight_off</v-icon>
                    &nbsp;Au moins une majuscule
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row align="end" justify="end">
              <v-col cols="6" align="end" justify="end" class="pt-6">
                <customButton
                  class="customBtn"
                  label="Confirmer"
                  btnType="connexion"
                  :elevation="0"
                  @click="$router.push('login')"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>


<script type="text/javascript">
import TextInput from "@/components/input/textInput";
import CheckBox from "@/components/input/checkboxInput.vue";
import customButton from "@/components/buttons/customButton.vue";
import LoginInput from '@/components/input/loginInput';

export default {
  components: {
    CheckBox,
    TextInput,
    customButton,
    LoginInput
  },
  props: {},
  data() {
    return {
      email: null,
      password: '',
      password_confirm: '',
      has_minimum_lenth: false,
      has_number: false,
      has_lowercsae: false,
      has_uppercase: false,
      has_special: false,
    };
  },
  methods: {},
  created() {
    this.email = this.$router.currentRoute.params.email;
    document.body.querySelector('.v-main__wrap').style.backgroundColor = '#fd5d5c';

  },
  computed: {},
  watch:{
            password(){
                this.has_minimum_lenth = (this.password.length > 8);
                this.has_number    = /\d/.test(this.password);
                this.has_lowercase = /[a-z]/.test(this.password);
                this.has_uppercase = /[A-Z]/.test(this.password);
                this.has_special   = /[!@#\$%\^\&*\)\(+=._-]/.test(this.password);
            }
        }
};
</script>
